/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as registerInstance } from './index-C_ZKddLG.js';
import './common-D-vggmh2.js';

const TestComponent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
};

export { TestComponent as test_component };
//# sourceMappingURL=test-component.entry.js.map
